module.exports = __webpack_public_path__ + "c.no2.19587d59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/c.no2.jpg
// module id = roXP
// module chunks = 0